<template>
  <div class="c-checkbox">
    <input
      type="checkbox"
      :id="name + id"
      inputmode="numeric"
      :disabled="disabled"
      class="c-checkbox-input w-full h-12 outline-none"
      :class="{ disabled: disabled }"
      step="1"
      :name="name"
      v-model="val"
    />
    <label :for="name + id">
      <slot name="label-content" />
    </label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CInput',
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      defaul: '',
    },
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('update:value', newValue);
        this.$emit('change');
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.c-checkbox {
  display: block;
  min-height: 1.5em;
  padding-left: 1.5em;
  margin-bottom: 0.125em;
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
}

.c-checkbox-input {
  width: 20px;
  height: 20px;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  position: relative;
  border-radius: 3px;
  margin-right: 0.5em;
  float: left;
  margin-left: -1.5em;

  &:before {
    display: block;
    position: absolute;
    width: 18px;
    height: 18px;
    top: 0;
    left: 0;
    content: '';
  }

  &:checked {
    background: linear-gradient(to right, rgb(129, 70, 255), rgb(70, 89, 255));
    border-color: #0d6efd;
  }

  &:checked[type='checkbox']::before {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
  }
}

.input-wrapper {
  @apply pl-6 pr-2;
  &.error {
    border-color: red;
  }
}
</style>
